import * as React from 'react';
import VerifyAccountCtrl from '@webapp/controllers/registration/verify-account';
import ResendCodeCtrl from '@webapp/controllers/registration/resend-code';

interface RegistrationVerifyPageProps {
  account: string | null;
  contact: string | null;
}

const RegistrationVerifyPage: React.FC<RegistrationVerifyPageProps> = ({
  account,
  contact,
}) => (
  (
    <section>
      <VerifyAccountCtrl account={account} />
      <ResendCodeCtrl username={account as string} contact={contact} />
    </section>
  )
);

export default RegistrationVerifyPage;
